import React from 'react';
import { connect } from 'react-redux';
import AlertMessageModal from 'react/containers/modals/AlertMessageModal';
import routeSummary from 'react/api/actions/routeSummary';
import CrudTab from 'react/containers/pages/CrudTab';
import { fixGridAndFilterBuilder } from 'react/utils/utils';
import RouteSummaryMissingDriverModal from '../modals/RouteSummaryMissingDriverModal/RouteSummaryMissingDriverModal';
import RouteSummaryAssignDriverModal from '../modals/RouteSummaryAssignDriverModal/RouteSummaryAssignDriverModal';

class RouteSummary extends CrudTab {
  static tabName = 'RouteSummary';

  namespaces = [
    'RouteSummaryRoutes',
    'RouteSummaryStops',
    'RouteSummaryOrders',
    'RouteSummaryLineItems'
  ];

  createContent = () => {
    const tabPanel = document.querySelector('#RouteSummary');
    const divAllContent = document.createElement('div');
    divAllContent.id = 'allContent';
    const fragment = document.createDocumentFragment();
    const sidebar = new Monet.UI.SidebarTransition('left');
    Monet.Session.RouteSummary.sidebar = sidebar;
    fragment.appendChild(sidebar.render());
    const divContent = document.createElement('div');
    divContent.id = 'contentContainer';
    divContent.className = 'grid_list_template';
    sidebar.setContent(divContent);
    divAllContent.appendChild(fragment);
    tabPanel.appendChild(divAllContent);
    sidebar.init();
  };

  goToRouter = () => {
    const { tab } = this.props;
    /**
     * "String".match(subRouterPattern);
     * return ["String", ${subRouter}];
     */
    const subRouterPattern = /RouteSummary\/(Stops|OrderAndLineItems)/i;
    const { pathname } = tab;
    const matches = pathname.match(subRouterPattern) || [];
    const subRouter = matches[1] && matches[1].toLowerCase();
    if (subRouter === 'stops') {
      /**
       * "String".match(oldSignatureURLPattern);
       * return ["String", ${routeId}, ${stopKey}, ${filter}];
       */
      const oldSignatureURLPattern =
        /RouteSummary\/Stops\/Route\/(\d+)\/Stop\/(.+)\/(Signature)/i;
      /**
       * "String".match(newSignatureURLPattern);
       * return ["String", ${filter}, ${routeId}, , ${stopKey}];
       */
      const stopFilterURLPattern =
        /RouteSummary\/Stops\/filter\/(\w+)\/route\/(\d*)(\/stop\/(.+))?/i;

      let routeId;
      let stopKey;
      let filter;
      if (oldSignatureURLPattern.test(pathname)) {
        [, routeId, stopKey, filter] = pathname.match(oldSignatureURLPattern);
      } else if (stopFilterURLPattern.test(pathname)) {
        [, filter, routeId, , stopKey] = pathname.match(stopFilterURLPattern);
      }
      App.Forms.RouteSummaryStops.filterFromReports = filter
        ? { filter, routeId, stopKey }
        : null;

      if (filter && filter.toLowerCase() === 'signature') {
        App.Views.RouteSummary.renderGridAndShowSignature();
      } else {
        App.Views.RouteSummary.showGridStop();
      }
    } else if (subRouter) {
      App.Views.RouteSummary.showOrdersAndLineItems();
    } else {
      App.Views.RouteSummary.showGridRoutes();
    }
  };

  componentDidMount() {
    if (!Monet.Session.RouteSummary) {
      Monet.Session.RouteSummary = {};
    }

    for (const namespace of this.namespaces) {
      App.Objects[namespace] = new App.Routers[namespace]();
    }

    this.createContent();
    this.goToRouter();
  }

  componentDidUpdate(prevProps) {
    const {
      active,
      tab: { pathname, extraArgs }
    } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;
    const didChangeTab = pathname !== prevProps.tab.pathname;
    const forceUpdate = isComingFromAnotherTab && didChangeTab;

    if (isComingFromAnotherTab && active) {
      fixGridAndFilterBuilder();
    }

    if (
      (!isComingFromAnotherTab && active && didChangeTab) ||
      extraArgs !== prevProps.tab.extraArgs ||
      forceUpdate
    ) {
      this.goToRouter();
    }
  }

  render() {
    const {
      tab: { key: liveKey },
      active,
      isAlertModalOpen,
      closeModalAction,
      alertModalContent,
      isAlertModalExpanded,
      toggleContentAction,
      isMissingDriverModalOpen,
      isAssignDriverModalOpen
    } = this.props;
    const className = `gmTabs__panel ${active ? this.activeClassName : ''}`;
    return (
      <div className={className}>
        <div id={liveKey} style={this.style}>
          <AlertMessageModal
            title={Monet.I18n.getResourcesByKey('RouteSummary')}
            isCancelable
            isExpanded={isAlertModalExpanded}
            isOpen={isAlertModalOpen}
            content={alertModalContent}
            closeModalAction={closeModalAction}
            toggleContentAction={toggleContentAction}
          />
          {isMissingDriverModalOpen && (
            <RouteSummaryMissingDriverModal isOpen={isMissingDriverModalOpen} />
          )}
          {isAssignDriverModalOpen && (
            <RouteSummaryAssignDriverModal isOpen={isAssignDriverModalOpen} />
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  isAlertModalOpen: state.routeSummary.getIn(['alertMessageModal', 'isOpen']),
  isAlertModalExpanded: state.routeSummary.getIn([
    'alertMessageModal',
    'isExpanded'
  ]),
  alertModalContent: state.routeSummary.getIn(['alertMessageModal', 'content']),
  isMissingDriverModalOpen: state.routeSummary.getIn([
    'missingDriverModal',
    'isOpen'
  ]),
  isAssignDriverModalOpen: state.routeSummary.getIn([
    'assignDriverModal',
    'isOpen'
  ])
});

const mapDispatchToProps = {
  closeModalAction: routeSummary.actionCreators.alertMessageModal.closeModal,
  toggleContentAction:
    routeSummary.actionCreators.alertMessageModal.toggleContent
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteSummary);
